import 'animate.css';
import React, { Component } from 'react';

import InteractionObserverManager from './managers/interaction_observer_manager.jsx';
import ScrollManagerViewerContainer from './managers/scroll_manager_for_viewer_container.jsx';
import SearchHotkeyManagerContainer from './managers/search_hotkey_manager_container.jsx';
import SubpageResizeEventManager from './managers/subpage_resize_event_manager_container.jsx';

import NeedsRefreshManagerContainer from './needs_refresh/needs_refresh_manager_container.jsx';
import SubpageViewerContainer from './subpages/subpage_viewer_container.jsx';

class SiteViewer extends Component {

  constructor() {
    super();
  }

  componentDidMount() {
    // the parent component will not finish mounting until all of its children
    // are also finished mounting so this allows us to know that React has
    // setup all of its relevant nodes.
    window.prerenderReady = true;
  }

  render() {
    return (
      <NeedsRefreshManagerContainer>
        <InteractionObserverManager>
          <SubpageResizeEventManager>
            <SearchHotkeyManagerContainer>
              <ScrollManagerViewerContainer>
                <SubpageViewerContainer {...this.props} />
              </ScrollManagerViewerContainer>
            </SearchHotkeyManagerContainer>
          </SubpageResizeEventManager>
        </InteractionObserverManager>
      </NeedsRefreshManagerContainer>
    );
  }

}

export default SiteViewer;
